package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Certificate
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.PeriodeSelector
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.models.CertificatState
import io.horion.cv.styles.CertificateEqualFieldStyle
import io.horion.cv.styles.CertificateFieldsRowStyle
import io.horion.cv.styles.CertificateFormStyle
import org.jetbrains.compose.web.css.px

@Composable
fun CertificatForm(
    index: Int,
    state: CertificatState,
    cvViewModel: CvViewModel,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {
    val updateVM = {
        val dateValue =
            if (state.isOngoing) {
                "En cours"
            } else {
                "${state.mois}-${state.annee}"
            }

        val updatedCert = Certificate(
            name = state.certificat,
            date = dateValue,
            description = state.description
        )

        cvViewModel.updateCertificate(
            index,
            updatedCert
        )
    }

    Column(
        modifier = CertificateFormStyle.toModifier()
    ) {
        Row(
            modifier = CertificateFieldsRowStyle.toModifier()
        ) {
            TextFormField(
                label = "Certificats",
                value = state.certificat,
                onValueChange = {
                    state.certificat = it
                    updateVM()
                },
                modifier = CertificateEqualFieldStyle.toModifier()
            )

            PeriodeSelector(
                month = state.mois,
                year = state.annee,
                isOngoing = state.isOngoing,
                onMonthChange = {
                    state.mois = it
                    updateVM()
                },
                onYearChange = {
                    state.annee = it
                    updateVM()
                },
                onOngoingChange = {
                    state.isOngoing = it

                    if (it) {
                        state.mois = ""
                        state.annee = ""
                    }

                    updateVM()
                },
                modifier = CertificateEqualFieldStyle.toModifier()
            )
        }

        RichTextDescription(
            label = "Description",
            value = state.description,
            onValueChange = {
                state.description = it
                updateVM()
            },
            modifier = Modifier
                .fillMaxWidth()
                .minWidth(0.px)
        )

        FormActionButtons(
            onDelete = onDelete,
            onComplete = onComplete
        )
    }
}